import DcoDerImage_03 from "../assets/DcoDerImage_03.gif";
import DcoDerImage_04 from "../assets/DcoDerImage_04.gif";
import DcoDerImage_05 from "../assets/DcoDerImage_05.gif";
import DcoDerImage_10 from "../assets/DcoDerImage_10.gif";
import DcoDerImage_11 from "../assets/DcoDerImage_11.gif";
import DcoDerImage_12 from "../assets/DcoDerImage_12.gif";
import DcoDerImage_17 from "../assets/DcoDerImage_17.gif";
import DcoDerImage_18 from "../assets/DcoDerImage_18.gif";
import DcoDerImage_19 from "../assets/DcoDerImage_19.gif";
import DcoDerImage_24 from "../assets/DcoDerImage_24.gif";
import DcoDerImage_25 from "../assets/DcoDerImage_25.gif";
import DcoDerImage_26 from "../assets/DcoDerImage_26.gif";
import DcoDerImage_27 from "../assets/DcoDerImage_27.gif";
import DcoDerImage_30 from "../assets/DcoDerImage_30.gif";
import DcoDerImage_31 from "../assets/DcoDerImage_31.gif";
import DcoDerImage_32 from "../assets/DcoDerImage_32.gif";
import DcoDerImage_33 from "../assets/DcoDerImage_33.gif";
import DcoDerImage_34 from "../assets/DcoDerImage_34.gif";
import Logo from "../assets/Logo.svg";
import Resume from "../assets/RESUME Praiz Edited.pdf";

const assets = {
  DcoDerImage_03,
  DcoDerImage_04,
  DcoDerImage_05,
  DcoDerImage_10,
  DcoDerImage_11,
  DcoDerImage_12,
  DcoDerImage_17,
  DcoDerImage_18,
  DcoDerImage_19,
  DcoDerImage_24,
  DcoDerImage_25,
  DcoDerImage_26,
  DcoDerImage_27,
  DcoDerImage_30,
  DcoDerImage_31,
  DcoDerImage_32,
  DcoDerImage_33,
  DcoDerImage_34,
  Logo,
  Resume,
};
export default assets;
